/**
 * Contact Form Manager
 * Manages form submission and consent modal for the contact page
 */

/**
 * Contact Form Manager
 * Manages form submission and consent modal for the contact page and section
 */

const ContactManager = (() => {
    const CONFIG = {
        // IDs for section form (Partial View)
        formId: 'contactForm',
        // Common Modal IDs
        modalId: 'consentModal',
        openModalBtnId: 'openConsentModal',
        
        // Page specific IDs (Full Page View)
        pageOpenModalBtnId: 'openConsentModalPage',
        pageCheckboxId: 'invalidCheckPage',
        
        closeModalBtnId: 'closeConsentModal',
        acceptBtnId: 'acceptConsentBtn',
        checkboxId: 'invalidCheck',
        
        apiEndpoint: '/contact/send-message'
    };

    /**
     * Modal controls
     */
    function toggleModal(show = true) {
        const modal = document.getElementById(CONFIG.modalId);
        if (!modal) return;

        if (show) {
            modal.classList.remove('hidden');
            document.body.style.overflow = 'hidden';
        } else {
            modal.classList.add('hidden');
            document.body.style.overflow = '';
        }
    }

    /**
     * Handle form submission
     */
    async function handleFormSubmit(e) {
        e.preventDefault();

        const form = e.target;
        const submitBtn = form.querySelector('button[type="submit"]');
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        // Basic validation for checkbox
        if (!data.AcceptPolicy) {
            if (window.Toast) {
                window.Toast.info('Bilgi Gerekli', 'Mesajınızı gönderebilmek için lütfen aydınlatma metnini onaylayınız.');
            } else {
                alert('Mesajınızı gönderebilmek için lütfen aydınlatma metnini onaylayınız.');
            }
            return;
        }

        // Prepare data for API (convert checkbox value to boolean)
        data.AcceptPolicy = data.AcceptPolicy === 'true';

        try {
            if (submitBtn) {
                submitBtn.disabled = true;
                const span = submitBtn.querySelector('span');
                if (span) {
                    submitBtn.dataset.originalText = span.innerText;
                    span.innerText = 'İşleniyor...';
                }
            }

            const response = await fetch(CONFIG.apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (result.success) {
                // GTM contact event
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'contact',
                    contact_method: 'form',
                    meta_event_id: (typeof window.mentaEventId === 'function' ? window.mentaEventId('contact') : 'contact-' + Date.now())
                });

                if (window.Toast) {
                    window.Toast.success('Tebrikler!', result.message || 'Mesajınız başarıyla iletildi. Size en kısa sürede dönüş yapacağız.');
                }
                form.reset();
            } else {
                // Backend tarafından dönen hata mesajı (Validasyon vb.)
                if (window.Toast) {
                    window.Toast.error('İşlem Başarısız', result.message || 'Mesajınız gönderilemedi. Lütfen eksik alanları kontrol edip tekrar deneyin.');
                }
            }
        } catch (error) {
            console.error('Contact Form Error:', error);
            if (window.Toast) {
                window.Toast.error('Bağlantı Hatası', 'Sunucu ile iletişim kurulamadı. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.');
            }
        } finally {
            if (submitBtn) {
                submitBtn.disabled = false;
                const span = submitBtn.querySelector('span');
                if (span && submitBtn.dataset.originalText) {
                    span.innerText = submitBtn.dataset.originalText;
                }
            }
        }
    }

    /**
     * Initialize event listeners
     */
    function init() {
        // 1. Partial form listeners
        const form = document.getElementById(CONFIG.formId);
        const openBtn = document.getElementById(CONFIG.openModalBtnId);
        
        // 2. Page form listeners (if any, form id is likely same 'contactForm' but just in case of conflicts or multi-forms)
        // Note: The provided HTMLs both use id="contactForm". If they are on same page, id conflict happens.
        // Assuming /iletisim page has one form, and home page has one form. 
        // If both exist on same page (e.g. footer + section), IDs must be unique. 
        // For now, attaching listener to any form with that ID found.
        
        if (form) {
            form.addEventListener('submit', handleFormSubmit);
        }

        const closeBtn = document.getElementById(CONFIG.closeModalBtnId);
        const acceptBtn = document.getElementById(CONFIG.acceptBtnId);
        const modal = document.getElementById(CONFIG.modalId);
        
        // 3. Page specific modal opener
        const pageOpenBtn = document.getElementById(CONFIG.pageOpenModalBtnId);

        if (openBtn) {
            openBtn.addEventListener('click', () => {
                window._activeConsentSource = 'partial'; // Track which checkbox to check
                toggleModal(true);
            });
        }
        
        if (pageOpenBtn) {
            pageOpenBtn.addEventListener('click', () => {
                window._activeConsentSource = 'page';
                toggleModal(true);
            });
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', () => toggleModal(false));
        }

        if (acceptBtn) {
            acceptBtn.addEventListener('click', () => {
                const source = window._activeConsentSource;
                let checkboxId = CONFIG.checkboxId; // default partial
                
                if (source === 'page') {
                    checkboxId = CONFIG.pageCheckboxId;
                }
                
                const checkbox = document.getElementById(checkboxId);
                if (checkbox) checkbox.checked = true;
                
                toggleModal(false);
            });
        }

        // Close on outside click
        if (modal) {
            modal.addEventListener('click', (e) => {
                if (e.target === modal) toggleModal(false);
            });
        }
    }

    return { init };
})();

// Load init
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ContactManager.init);
} else {
    ContactManager.init();
}
